import { render } from "./WarningComp.vue?vue&type=template&id=0014ec7a"
import script from "./WarningComp.vue?vue&type=script&lang=js"
export * from "./WarningComp.vue?vue&type=script&lang=js"

import "./WarningComp.vue?vue&type=style&index=0&id=0014ec7a&lang=css"

import exportComponent from "E:\\Web\\forgexsystem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__